import React from 'react';

export const IconSmallLinkLegacy: React.FC = (props = {}) => (
    <svg height="24" width="24" fill="none" viewBox="0 0 24 24" {...props}>
        {props.children}
        <path
            d="M9.937 13.98l-.353-.354 1.414-1.415.354.354c.729.729 2.072.756 3.005-.177l1.532-1.532 1.414 1.414-1.532 1.532c-1.605 1.606-4.22 1.792-5.834.177zm7.66-7.661c-.728-.729-2.071-.756-3.004.177l-1.21 1.21a5.482 5.482 0 00-2.37-.46l.633-.633 1.532-1.532c1.606-1.605 4.22-1.79 5.834-.176 1.614 1.614 1.429 4.228-.177 5.833l-1.532 1.532-1.414-1.414 1.532-1.532c.933-.933.906-2.276.177-3.005zm-3.535 3.535l.354.354-1.414 1.414-.354-.353c-.729-.73-2.072-.757-3.005.176L8.11 12.977l-1.414-1.414 1.532-1.532c1.605-1.605 4.219-1.79 5.833-.177zm-7.66 7.66c.729.73 2.072.757 3.005-.176l1.21-1.21a5.482 5.482 0 002.37.46l-.634.632-1.532 1.532c-1.605 1.606-4.219 1.791-5.833.177-1.615-1.614-1.429-4.228.176-5.834l1.533-1.532 1.414 1.414-1.532 1.532c-.933.934-.906 2.277-.177 3.006z"
            fill="#374050"
            fillRule="evenodd"
        />
    </svg>
);
